module.exports = __webpack_public_path__ + "static/media/awfxex32_119.31a608e8.ico";